import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const FREE_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'directBuy',
	dialogId: 'automation-free-limit-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.STANDARD_EDITION,
};
